import TSXComponent from '@/utils/tsx-component';
import PageView from '@/components/page-view';
import Component from 'vue-class-component';
import { TrinitySearch } from './Search';
import { Button } from '@ohu-mobile/core';
import './index.scss';

@Component({ name: 'trinity-search-view' })
export default class TrinitySearchView extends TSXComponent {
  public render() {
    return (
      <PageView title="三位一体报考查询"
        navBarFixed
        navBarProps={{ segmentation: [ 1, 2, 1 ] }}
        shareParams={{
          moduleCode: '三位一体',
          areaCode: '浙江',
          showAreaCode: 'C99',
        }}>
        <Button
          type="primary"
          link
          inline
          slot="navbar-right"
          to="article?moduleCode=三位一体&showAreaCode=C20&title=三位一体使用帮助&merge=1">
          使用帮助
        </Button>
        <TrinitySearch></TrinitySearch>
      </PageView>
    );
  }
}
